import { SELECT_LAYERS_TAB, SIDEBAR_EXPAND, SIDEBAR_COLLAPSE } from '../common/actionTypes';

const selectLayersTab = tab => ({
  type: SELECT_LAYERS_TAB,
  tab,
});

export const expandSidebar = () => ({
  type: SIDEBAR_EXPAND,
});

export const collapseSidebar = () => ({
  type: SIDEBAR_COLLAPSE,
});

export default selectLayersTab;



// WEBPACK FOOTER //
// ./src/actions/sidebarActions.js